import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Open, fontBarlow, QLinks } from './LeadDashboardMobile.module.css';
import { makeStyles } from '@material-ui/core/styles';
import { Drawer } from '@material-ui/core';
import WhatsAppIcon from '../../../images/icons/whatsApp_icon.svg';
import SvgComponent from '../../../common/components/SvgComponent/SvgComponent';
import SettingsPhoneIcon from '@material-ui/icons/SettingsPhone';
import DescriptionIcon from '@material-ui/icons/Description';
import EditIcon from '@material-ui/icons/Edit';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import moment from 'moment';
import MakeACall from '../../../components/MakeACall/MakeACall';
import Audit from '../../../containers/Audit/Audit';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../../common/utils/applicantionInfo';

import { navigate } from 'gatsby';
import AssignOwner from '../../../containers/RMDashboard/AssignOwner';
import { getAcl } from '../../../common/utils/acl-utils';
import { numberInTextFormat } from '../../../common/constants/numberInTextFormat';

const MoreDetailLeadPage = ({
  each,
  statusList,
  openFullDetail,
  setShowEditModal,
  setOpenFullDetail,
  getLoanTypeId,
  updateData,
  handleWhatsApp,
  setShowSendDoc
}) => {
  const [showAuditTrail, setShowAuditTrail] = useState(false);
  const [showAssignLeads, setShowAssignLeads] = useState(false);

  const [allowedToReassignRm, setAllowedToReassignRM] = useState(
    getAcl()?.acl?.can_assign_rm ? true : false
  );

  const useStyles = makeStyles({
    paperAnchorBottom: {
      borderTopRightRadius: '20px',
      borderTopLeftRadius: '20px'
    },
    root: {
      ['@media (min-width: 768px)']: {
        display: 'none'
      }
    }
  });
  const classes = useStyles();
  let detailData = [
    {
      key: 'RM Assigned',
      value: () => (
        <span
          className={`${allowedToReassignRm && 'text-blue-600'}`}
          onClick={() => setShowAssignLeads(true)}
        >
          {`${each?.rmName?.firstName || ''} ${each?.rmName?.middleName ||
            ''} ${each?.rmName?.lastName || ''}`}
        </span>
      )
    },
    { key: 'City', value: () => each?.propertyCity || '---' },
    { key: 'Source', value: () => each?.leadSource || '---' },
    {
      key: 'Sourcing date',
      value: () =>
        moment(each?.leadCreatedAt).isValid()
          ? moment(each?.leadCreatedAt).format('DD-MM-YY - hh-mm A')
          : '---'
    },
    {
      key: 'Last updated on',
      value: () =>
        moment(each?.leadUpdatedAt).isValid()
          ? moment(each?.leadUpdatedAt).format('DD-MM-YY - hh-mm A')
          : '---'
    },
    {
      key: 'Next follow up on',
      value: () =>
        moment(each?.nextFollowUpOn).isValid()
          ? moment(each?.nextFollowUpOn).format('DD-MM-YY - hh-mm A')
          : '---'
    }
  ];
  let quickLinks = [
    {
      key: 'Make a call',
      value: () => (
        <div className={`shadow rounded-full w-8 h-8 table mx-auto `}>
          <MakeACall
            phoneNumber={each?.leadApplicantPhone}
            leadId={each?.leadId}
            applicantId={each?.leadMainApplicantId}
            PhoneNumberClasses="hidden"
          />
        </div>
      )
    },
    {
      key: 'Whatsapp',
      value: () => (
        <div className={'table mx-auto  '} onClick={handleWhatsApp}>
          <SvgComponent
            img={WhatsAppIcon}
            className={`text-green-whatsAppIcon w-8 h-8 table mx-auto `}
          />
        </div>
      )
    },
    {
      key: 'Call Logs',
      value: () => (
        <div
          className="table mx-auto"
          onClick={() => navigate(`/app/calllog/${each?.leadId}`)}
        >
          <SettingsPhoneIcon
            className={`text-green-600 px-0.5 w-8 h-8 table mx-auto`}
          />
        </div>
      )
    },
    {
      key: 'Audit trail',
      value: () => (
        <div
          className="table mx-auto"
          onClick={() => {
            setApplicantionInfo({
              ...getApplicantionInfo,
              leadId: each?.leadId
            });
            setShowAuditTrail(true);
          }}
        >
          <DescriptionIcon
            className={`text-green-600 px-0.5 w-8 h-8 table mx-auto`}
          />
        </div>
      )
    },
    {
      key: 'Edit Lead',
      value: () => (
        <div className="table mx-auto" onClick={() => setShowEditModal(true)}>
          <EditIcon className={`text-green-600 px-0.5 w-8 h-8 table mx-auto`} />
        </div>
      )
    },
    {
      key: () => {
        if (each.status != 'Interested' && each.status != 'Lead Rejected')
          return <span className="opacity-25">PD</span>;
        if (each.status == 'Lead Rejected') return 'View PD';
        if (each.pdStatus == 'InProgress') return 'Review PD';
        return 'Start PD';
      },
      value: () => {
        let commonStyle = '';
        let commonFun = () => {};
        if (each?.status != 'Lead Rejected' && each?.status != 'Interested') {
          commonStyle = 'opacity-25';
        } else {
          let applicationDetails = {
            leadId: each.leadId,
            leadApplicantId: each.leadMainApplicantId,
            applicationStatus: each.status,
            leadData: each
          };
          setApplicantionInfo(applicationDetails);
          if (each.status == 'Lead Rejected') {
            commonFun = () => navigate('/app/dashboard/lead/view/pd/all');
          } else {
            let productId = getLoanTypeId(each?.loanProduct);
            commonFun = () =>
              navigate(`/app/dashboard/lead/pd?loanType=${productId}`);
          }
        }

        return (
          <div className="table mx-auto" onClick={() => commonFun()}>
            <SupervisedUserCircleIcon
              className={`text-green-600 px-0.5 w-8 h-8 table mx-auto ${commonStyle}`}
            />
          </div>
        );
      }
    },
    {
      key: 'Send Document',
      value: () => (
        <div className="table mx-auto" onClick={() => setShowSendDoc(true)}>
          <DescriptionIcon
            className={`text-green-600 px-0.5 w-8 h-8 table mx-auto`}
          />
        </div>
      )
    }
  ];

  return (
    <React.Fragment>
      <Drawer
        anchor="bottom"
        open={openFullDetail}
        onClose={() => {
          setOpenFullDetail(false);
        }}
        classes={{
          paperAnchorBottom: classes.paperAnchorBottom,
          root: classes.root
        }}
      >
        <div className="w-full px-5">
          <div className="flex">
            <p className="font-barlow-semi-bold w-full font-semibold my-3 text-lg text-black-1011 mx-1 capitalize ">
              {`${each?.leadName?.firstName || ' '} ${each?.leadName
                ?.middleName || ' '} ${each?.leadName?.lastName || ' '}`}
            </p>
            <CloseIcon
              className="float-right clear-both mr-1 w-14 my-3"
              style={{ color: '#858585' }}
              onClick={() => setOpenFullDetail(false)}
            />
          </div>
          <hr className="text-grey-greyLight my-4" />
          <div
            className="w-full overflow-auto "
            style={{ maxHeight: '70vh', overflow: 'auto' }}
          >
            <div className="w-full">
              <p
                className={`font-normal text-sm text-black-850 mt-1 ${fontBarlow}`}
              >
                {each?.leadId}
                <span
                  className={`${statusList[each?.status || 'Open']?.style ||
                    Open} ${fontBarlow} font-normal   ml-1 text-sm py-1 px-2 rounded-sm ml-2`}
                >
                  {each?.status || '---'}
                </span>
                <span
                  className={`${fontBarlow} font-normal text-black-850 bg-grey-thinGray ml-1 text-sm py-1 px-2 rounded-sm`}
                >
                  {each?.subStatus || '---'}
                </span>
              </p>
              <div className="w-full grid grid-cols-3 mt-6">
                <div className="w-full">
                  <p className="font-barlow font-normal text-xs text-black-1020 capitalize">
                    Loan Type
                  </p>
                  <p
                    className={` font-barlow-medium  font-semibold  text-sm text-black-1025`}
                  >
                    {each?.loanProduct || '---'}
                  </p>
                </div>
                <div className="w-full">
                  <p className="font-barlow font-normal text-xs text-black-1020 ">
                    Loan Amount
                  </p>
                  <p
                    className={`font-barlow-medium   font-semibold  text-sm text-black-1025`}
                  >
                    {each?.loanAmount && (
                      <span className="mr-0.5"> &#8377;</span>
                    )}
                    {numberInTextFormat(each.loanAmount)}
                  </p>
                </div>

                <div className="w-full">
                  <p className="font-barlow font-normal text-xs text-black-1020 ">
                    Credit Score
                  </p>
                  <p
                    className={`font-barlow-medium   font-semibold  text-sm text-black-1025 `}
                  >
                    {each?.creditScore || '---'}
                  </p>
                </div>
              </div>
            </div>

            <hr className="text-grey-greyLight my-4" />
            {detailData?.map((each, index) => (
              <div className=" py-1 grid grid-cols-3 items-center">
                <div className={`col-span-1`}>
                  <p className={`${fontBarlow} text-xs  text-black-1020 `}>
                    {each?.key}
                    <span className="float-right clear-both">:</span>
                  </p>
                </div>
                <div className="col-span-2">
                  <p
                    className={`${fontBarlow} font-semibold capitalize text-sm text-black-850 ml-4`}
                  >
                    {each?.value()}
                  </p>
                </div>
              </div>
            ))}
            <div className="w-full bg-ghostWhite rounded px-3 py-4 mt-6 mb-3">
              <p className="text-base font-semibold text-black-1011 ">
                Quick Links
              </p>
              <div className={`w-full grid ${QLinks}`}>
                {quickLinks?.map((each, index) => (
                  <div
                    className="mx-2 my-5 table"
                    onClick={() => setOpenFullDetail(false)}
                  >
                    <div className="bg-white items-center w-12 h-12 rounded  text-center pt-2 mx-auto">
                      {each?.value()}
                    </div>
                    <p className="text-black-1011 text-sm text-center mt-1">
                      {typeof each?.key == 'function' ? each?.key() : each?.key}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Drawer>

      {showAuditTrail && (
        <Audit
          setShowAuditTrail={setShowAuditTrail}
          showAuditTrail={showAuditTrail}
        />
      )}

      {showAssignLeads && allowedToReassignRm && (
        <AssignOwner
          leadId={each?.leadId}
          name={`${each?.leadName?.firstName || ''} ${each.leadName
            ?.middleName || ''} ${each?.leadName?.lastName || ''}`}
          ownerName={`${each?.rmName?.firstName || ''}  ${each?.rmName
            ?.middleName || ''} ${each?.rmName?.lastName || ''}`}
          row={each}
          setShowReassign={setShowAssignLeads}
          onSuccess={updateData}
          header="Current RM"
          actionHeader="Assign New RM"
          submitText="Changing RM for the lead. Please wait..."
        />
      )}
    </React.Fragment>
  );
};
export default MoreDetailLeadPage;
